module.exports = __webpack_public_path__ + "static/media/04_Ministeredesaffairesetrangeres.4a6ae959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/realisations/projet_affaires-etrangeres/04_Ministeredesaffairesetrangeres.jpg
// module id = 1177
// module chunks = 37